
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import React from 'react';
import AuthProtected from './Components/Authorization/AuthProtected';
import LoginPage from './Pages/LoginPage/LoginPage';
import UnderConstructionPage from './Pages/GeneralPages/UnderConstructionPage';
import AppLayout from './AppLayout';
import OverviewPage from './Pages/OverviewPage/OverviewPage';
import UsersPage from './Pages/UsersPage/UsersPage';
import AutoCountPage from './Pages/AutoCountPage/AutoCountPage';
import TipJarPage from './Pages/TipJarPage/TipJarPage';
import HelpPage from './Pages/HelpPage/HelpPage';
import WhatsNewPage from './Pages/WhatsNewPage/WhatsNewPage';
import CountPeriodManagementPage from './Pages/CountPeriodManagementPage/CountPeriodManagementPage';
import ManualCountPage from './Pages/CountingPage/ManualCountPage';
import ImportCsvPage from './Pages/ImportCsvPage/ImportCsvPage';
import WorkerDetailsPage from './Pages/WorkerDetailsPage/WorkerDetailsPage';

export default class App extends React.Component {

  constructor(props: any) {
    super(props);
  }

  render() {
    return (
        <BrowserRouter>
          <Routes>
                {/* Public */}
                <Route path="/login" element={<LoginPage from="/" />} />

                {/* Protected layout: stays mounted; its <Outlet/> changes */}
                <Route
                    element={
                        <AuthProtected permissions={["User"]}>
                            <AppLayout />
                        </AuthProtected>
                    }
                >
                    <Route index element={<Navigate to="/dashboard" replace />} />
                    
                    <Route path="dashboard" element={<OverviewPage />} />
                    <Route path="organisation">
                        <Route path="team" element={<UsersPage />} />
                        <Route path="permissions" element={<UnderConstructionPage />} />
                        <Route path="locations" element={<UnderConstructionPage />} />
                        <Route path="settings" element={<UnderConstructionPage />} />
                    </Route>
                    <Route path="counting">
                        <Route path="manual" element={<ManualCountPage />} />{/* <Route path="manual" element={<CountingTabsPage />} /> */}
                        <Route path="auto" element={<UnderConstructionPage />} />
                        <Route path="import" element={<ImportCsvPage />} />
                    </Route>
                    <Route path="finance">
                        <Route path="tipjar" element={<TipJarPage />} />
                        <Route path="payouts" element={<UnderConstructionPage />} />
                        <Route path="countperiods" element={<CountPeriodManagementPage />} />
                    </Route>
                    <Route path="workerdetails" element={<WorkerDetailsPage />} />
                    <Route path="integrations" element={<UnderConstructionPage />} />
                    <Route path="help" element={<HelpPage />} />
                    <Route path="whatsnew" element={<WhatsNewPage />} />

                    {/* Extras */}
                    <Route path="underconstruction" element={<UnderConstructionPage />} />
                    <Route path="*" element={<>404 - Page not found</>} />
                </Route>
            </Routes>
        </BrowserRouter>
      );
  }
}
